import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { CONTACT, SERVICES } from "../data/translations";
import Logo from "./Logo";

const Footer = () => {
  const { lang, t } = useLanguage();
  const navLinks = [
    ["/", t.nav.home],
    ["/about", t.nav.about],
    ["/services", t.nav.services],
    ["/references", t.nav.references],
    ["/contact", t.nav.contact],
  ];
  const idFor = (to) => (to === "/" ? "home" : to.slice(1));

  return (
    <footer className="bg-black border-t border-white/10" data-testid="footer">
      <div className="container-site py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-[1.3fr_0.8fr_1fr_1.3fr]">
        <div>
          <Logo large />
          <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">{t.footer.blurb}</p>
        </div>
        <div>
          <h4 className="mini-label mb-5">{t.footer.linksTitle}</h4>
          <ul className="space-y-3">
            {navLinks.map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${idFor(to)}`} className="text-sm text-slate-300 hover:text-brand transition-colors">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mini-label mb-5">{t.footer.servicesTitle}</h4>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to="/services" data-testid={`footer-service-${s.id}`} className="text-sm text-slate-300 hover:text-brand transition-colors">
                  {s[lang].title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="mini-label mb-5">{t.footer.contactTitle}</h4>
          <ul className="space-y-4 text-sm text-slate-300">
            <li className="flex gap-3">
              <MapPin size={16} className="text-brand shrink-0 mt-0.5" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
            <li className="flex gap-3 items-center">
              <Phone size={16} className="text-brand shrink-0" />
              <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="hover:text-brand transition-colors">
                {CONTACT.phone}
              </a>
            </li>
            <li className="flex gap-3 items-center">
              <Mail size={16} className="text-brand shrink-0" />
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-brand transition-colors">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-site py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 font-mono text-[11px] tracking-wider text-slate-500">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} MVALOG Int. Transport Co. Ltd. — {t.footer.rights}
          </p>
          <p>Mersin, Türkiye</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
